import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { PackagesEndpointMethod } from '../../packagesGrid/types';
import { SendDownloadLinksResponse } from '../../types/types';

export class SendDownloadLinksFormBaseDataProvider extends BaseWebComponentDataProvider {
  private dataProviderType = DataProviderType.CORE;
  private endpoint = 'Packages';

  public async sendDownloadLinksEmail(packageId: string, emails: Array<string>, ringId: string | number): Promise<SendDownloadLinksResponse> {
    return ConsoleRequest.createRequest<SendDownloadLinksResponse>({
      dataProviderType: this.dataProviderType,
      payload: { packageId: packageId, emails: emails, ringId: ringId },
      endpoint: this.endpoint,
      method: PackagesEndpointMethod.SEND_LINKS_BY_EMAIL,
    });
  }
}
